import FilterMenu from "./FilterMenu";

const SearchAndOrFilter = ({
  filterName,
  fieldName,
  options,
  appliedFilters,
  setAppliedFilters,
  setFilterLogic,
  filterLogic,
  ...props
}) => {
  return (
    <FilterMenu
      filterName={filterName}
      fieldName={fieldName}
      options={options}
      appliedFilters={appliedFilters}
      setAppliedFilters={setAppliedFilters}
      showSearch={true}
      logicControl={true}
      setFilterLogic={setFilterLogic}
      filterLogic={filterLogic}
      {...props}
    />
  );
};

export default SearchAndOrFilter;
